export const RECEIVE_GET_REPORTS = 'RECEIVE_GET_REPORTS'
export const REQUEST_GET_REPORTS = 'REQUEST_GET_REPORTS'
export const FAILED_GET_REPORTS = 'FAILED_GET_REPORTS'
